import VehicleManufacturer from "./VehicleManufacturer";

export default class VehicleModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.name = data.name ?? '';
			this.description = data.description;
			
			if (data.manufacturer?.id) {
				this.manufacturer = new VehicleManufacturer(data.manufacturer);
			}
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	name = '';
	description: string | null = null;
	manufacturer: VehicleManufacturer | null = null;
}
